import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';

import { CampaignContact } from '../models/campaign.model';
import { BaseService } from './base.service';

export class CallCenterService extends BaseService {

	constructor(http: AxiosInstance) {
		super(http);
	}

	nextContact(id: number): Promise<CampaignContact> {
		return this.mapResponse<CampaignContact>(this.http.get(`/ws/callcenter/campaign/${id}/next`), CampaignContact);
	}

	sendAction(action: string, model: CampaignContact): Promise<CampaignContact> {
		return this.mapResponse<CampaignContact>(this.http.post(`/ws/callcenter/campaign/action/${action}`, classToPlain(model)), CampaignContact);
	}

	printContacts(oid: number, campid: number) {
		return this.mapResponse(this.http.post('/ws/campaigncontact/print/contacts/campaign', { campid, oid }, { responseType: 'blob' }));
	}
}